import {
    availableBarsRestaurantsJobTypes,
    availableCastingJobTypes,
    availableEventSupportJobTypes,
    availableMasterOfCeremoniesJobTypes
} from '@/helpers/availableJobTypeHelper'

export default function () {
    return {
        job: {
            event: {
                user: {}
            },
            canAddFeedback: false
        },
        showJobAcceptedDialog: false,
        showJobDeniedDialog: false,
        showMessages: false,
        showJobAcceptErrorDialog: false,
        showCancelJobDialog: false,
        showCancelJobResultDialog: false,
        cancelJobResult: '',
        jobAcceptError: null,
        allAvailableJobTypes: [
            ...availableCastingJobTypes,
            ...availableMasterOfCeremoniesJobTypes,
            ...availableEventSupportJobTypes,
            ...availableBarsRestaurantsJobTypes
        ],
    }
}
